import { Injectable, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, Event as RouterEvent } from '@angular/router';
import { Meta } from '@angular/platform-browser';
import { filter, Subscription } from 'rxjs';
import { isExcludedFromIndex } from './excluded-routes.const';

@Injectable({
  providedIn: 'root',
})
export class RobotsService implements OnDestroy {
  private routerSubscription: Subscription;
  private noIndexTag = { name: 'robots', content: 'noindex' };

  constructor(private router: Router, private meta: Meta) {
    this.routerSubscription = this.router.events.pipe(
      filter((event: RouterEvent): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.handleRouteChange(event.urlAfterRedirects);
    });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    this.removeNoIndexTag();
  }

  private handleRouteChange(url: string): void {
    // isExcludedFromIndex normaliza el slash inicial y soporta rutas con
    // parámetros (':id'), que la comparación anterior con includes() no cubría
    if (isExcludedFromIndex(url)) {
      this.addNoIndexTag();
    } else {
      this.removeNoIndexTag();
    }
  }

  private addNoIndexTag(): void {
    this.meta.addTag(this.noIndexTag);
  }

  private removeNoIndexTag(): void {
    this.meta.removeTag(`name='${this.noIndexTag.name}'`);
  }
}
